import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiMenuItem = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiMenuItem: {
      defaultProps: {},
      styleOverrides: {
        root: {
          height: 'unset',
          gap: spacing(1.5),
          padding: spacing(1.5, 2),
          '&.Mui-selected': {
            '&:hover': {
              backgroundColor: palette.action.hover,
            },
          },
          /**
           * keyboard control:
           */
          '&.Mui-selected.Mui-focusVisible, &.Mui-focusVisible': {
            backgroundColor: palette.action.hover,
          },
          '+.MuiDivider-root': {
            margin: 0,
          },
          '> .MuiListItemIcon-root': {
            minWidth: 'unset',
          },
        },
      },
    },
  }) satisfies ComponentCreation
